import gql from 'graphql-tag';
// import { QUERY_ASSETS } from 'src/modules/assets';
// import { FRAGMENT_HERO } from 'src/modules/layout/components/block/hero/queries';
// import { articlesToLoad, articlesPerPage, filteredArticlesPerPage } from '../store/types';
import { FRAGMENT_BANNER } from 'src/modules/global/components/banner/queries';

export const articlesPerPage = 100;
export const filteredArticlesPerPage = 12; //12
export const articlesToLoad = 6; //6

export const FRAGMENT_ARTICLE_CARD = gql`
  fragment articleCardFields on Article {
    slug
    article_category {
      name_de
      name_en
    }
    hero {
      title_en
      title_de
      image {
        url
      }
    }
    reference {
      reference_category {
        id
        name_en
        name_de
      }
    }
  }
`;

export const QUERY_MAGAZINE_ARTICLE = gql`
  query MagazineArticle {
    magazine {
      article {
        id
        slug
        article_category {
          name_de
          name_en
        }
        hero {
          title_en
          title_de
          image {
            url
            formats
          }
        }
      }
      banner_top {
        ...banner
      }
      banner_bottom {
        ...banner
      }
    }
  }
  ${FRAGMENT_BANNER}
`;

export const QUERY_ARTICLES_LISTING = gql`
  query ArticleListing($excludeArticle: ID) {
    articles(where: { id_ne: $excludeArticle, _or:[{reference_null: true}, {featured_project: true}] }, limit: ${articlesPerPage}, sort: "published_at:desc") {
      slug
      article_category {
        name_de
        name_en
      }
      hero {
        title_en
        title_de
        image {
          url
          formats
        }
      }
    }
    articlesCount(where: { id_ne: $excludeArticle })
  }
`;

export const QUERY_FILTERED_ARTICLES_LISTING = gql`
  query FilteredArticles($filterCategory: String!, $excludeArticle: ID) {
    articles(
      where: { id_ne: $excludeArticle, _or:[{reference_null: true}, {featured_project: true}], article_category_in: $filterCategory }
      limit: ${filteredArticlesPerPage}
      sort: "published_at:desc"
    ) {
      slug
      article_category {
        name_de
        name_en
      }
      hero {
        title_en
        title_de
        image {
          url
        }
      }
    }
    articlesCount(where: { id_ne: $excludeArticle, article_category: $filterCategory })
  }
`;

export const QUERY_MORE_ARTICLES_LISTING = gql`
  query MoreArticles($start: Int!, $excludeArticle: ID) {
    articles(
      where: { id_ne: $excludeArticle, _or:[{reference_null: true}, {featured_project: true}]}
      limit: ${articlesToLoad}
      start: $start
      sort: "published_at:desc"
    ) {
      slug
      article_category {
        name_de
        name_en
      }
      hero {
        title_en
        title_de
        image {
          url
        }
      }
    }
  }
`;

export const QUERY_MORE_FILTERED_ARTICLES_LISTING = gql`
  query MoreFilteredArticles($filterCategory: String, $start: Int!, $excludeArticle: ID) {
    articles(
      where: { id_ne: $excludeArticle, _or:[{reference_null: true}, {featured_project: true}], article_category_in: $filterCategory }
      limit: ${articlesToLoad}
      start: $start
      sort: "published_at:desc"
    ) {
      slug
      article_category {
        name_de
        name_en
      }
      hero {
        title_en
        title_de
        image {
          url
        }
      }
    }
  }
`;

export const QUERY_ARTICLE_CATEGORIES = gql`
  query ArticleCategories {
    articleCategories: searchArticleCategories {
      id
      name_en
      name_de
    }
  }
`;
